import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Avatar, Button, Tooltip } from "@mui/material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { IconButton } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useKeycloak } from "@react-keycloak/web";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import MenuIcon from "@mui/icons-material/Menu";
import Colors from "../../theme/colors.json";
import InsurproLogo from "../../assets/svg/InsurproLogo.svg";
import InsurproLogoBlue from "../../assets/svg/InsuproLogoBlue.svg";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { INITIAL_THEME } from "../../theme";

const drawerWidth = 100;

interface tabItems {
  title: string;
  index: number;
  icon: React.ReactNode;
  path: string;
}
interface tabStylesItems {
  activeIconColor: string;
  activeIndicatorColor: string;
  scrollButtonColor: string;
  menusBackgroundColor: string;
}

interface logoItems {
  title: string;
  icon: string;
}

interface propsSchema {
  tabs: tabItems[];
  activeTab: number;
  setActiveTab: (activeTab: number) => void;
  tabStyles: tabStylesItems;
  logo: logoItems;
  handleLogoClick: (item: any) => void;
  footerLogo: string;
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  sideBarLogo: {
    width: "3.7rem !important",
    height: "3.7rem !important",
    marginTop: "20px !important",
  },
  sideBarDrawer: {
    width: drawerWidth,
    flexShrink: 0,
    [`& .MuiDrawer-paper`]: {
      width: drawerWidth,
      boxSizing: "border-box",
    },
    // zIndex: 10000,
  },
  sideBarTabs: {
    height: "65vh",
    marginTop: "20px !important",
    // "&.MuiTabs-root .MuiTabScrollButton-root svg": {
    //   color: (tabStyles: any) => tabStyles.scrollButtonColor || "blue",
    // },

    "&.MuiTabs-root .Mui-selected": {
      // color: (tabStyles: any) => tabStyles.activeIconColor || "blue",
      // background:
      //   "radial-gradient(50% 50% at 50% 50%, #FFFFFF 0%, #DFEAFF 100%)",
    },
    // ".MuiSvgIcon-root": {
    //   width: "1.4em",
    //   height: "1.4em",
    // },
    // ".MuiButtonBase-root": {
    //  color: theme.palette.primary.main
    // },
    ".MuiButtonBase-root:hover": {
      color: "#F15830",
    },
    "&.MuiTabs-root .MuiTabs-scroller ": {
      backgroundColor: (tabStyles: any) =>
        tabStyles.menusBackgroundColor || "white",
    },
    "&.MuiTabs-root .MuiTabs-indicator": {
      backgroundColor: (tabStyles: any) =>
        tabStyles.activeIndicatorColor || "blue",
      width: "6%",
      borderRadius: "10px 0px 0px 10px",
      // height: "10vh !important",
      // marginTop: "10px !important",
    },
  },
  sideBarTab: {
    padding: "15px 25px 15px 25px",
    // color: theme.palette.secondary.main,
    fontSize: "1.6rem !important",
  },
  sideBarBottomContainer: {
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    width: "100%",
  },
  logoutIconStyles: {
    width: 48,
    height: 48,
    marginTop: 5,
    marginBottom: "10px !important",
  },
  sideBarFooterText: {
    font: "Inter",
    fontWeight: 400,
    lineHeight: "12.1px",
    fontSize: "10px",
    paddingTop: "8px !important",
    textTransform: "uppercase",
  },
  sideBarFooterContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#FAE9E5",
    gap: 10,
    width: "100%",
  },
  sideBarFooterLogo: {
    marginBottom: "8px",
    width: "65.6px",
  },
  insurProSidebarContainer: {
    display: "flex",
    flexDirection: "row",
  },
  insurProMenuSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    position: "fixed",
    zIndex: theme.zIndex.drawer - 1,
    // zIndex: 9999,
    // background: `${INITIAL_THEME.palette.primary.main}`,
    background: Colors.WHITE_BACKGROUND,
    width: "100%",
  },
  insurProMenuHeader: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },

  insurProMenuTitle: {
    textTransform: "capitalize",
    margin: "auto",
    fontWeight: 600,
    fontSize: "1.3rem",
    color: theme.palette.primary.main,
  },
  insurProMenuIcon: {
    // color: Colors.WHITE,
    color: theme.palette.secondary.main,
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer"
  },
  appLogo: {
    height: "1.9rem",
    width: "3.125rem",
  },
  drawerLogoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // background: theme.palette.primary.main,
    marginTop: "20px",
    width: 100,
  },
  drawerLogo: {
    width: "3.3rem",
    height: "3.3rem !important",
    // marginTop: "20px !important",
  },
  userSection: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "0.3rem",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    paddingRight: "2%",
  },
  userTitle: {
    fontSize: theme.fontSizes.SMALL,
    textTransform: "capitalize",
  },
  menuDownIcon: {
    padding: "unset",
  },
  selectEffect: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "3.125rem",
    height: "3.125rem",
    borderRadius: "50%",
    background: "radial-gradient(50% 50% at 50% 50%, #FFFFFF 0%, #DFEAFF 100%)",
  },
  hiddenDiv: {
    visibility: "hidden",
  },
}));

const selectedIcon = {
  fill: INITIAL_THEME.palette.primary.main,
};

const unSelectedIcon = {
  fill: Colors.ICON_UNSELECTED,
};

export default function Sidebar(props: propsSchema) {
  const {
    tabs,
    activeTab,
    setActiveTab,
    tabStyles,
    logo,
    handleLogoClick,
    footerLogo,
  } = props;

  const classes = useStyles(tabStyles);
  const navigate = useNavigate();
  const { keycloak } = useKeycloak();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  let windowLocation = window.location.pathname;

  const { filteredRoutes } = useSelector((state: any) => ({
    filteredRoutes: state.filteredRoutes,
  }));

  const [screenTitle, setScreenTitle] = React.useState("");

  //Profile Menu code
  const [anchorElMenu, setAnchorElMenu] = React.useState<null | HTMLElement>(
    null
  );
  const openMenu = Boolean(anchorElMenu);
  const handleClickMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElMenu(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorElMenu(null);
  };

  //End

  const getScreenTitle = () => {
    tabs.find((item) => {
      if (item?.path === window?.location?.pathname) {
        setScreenTitle(item?.title);
        setOpen(false);
      }
    });
  };

  const [open, setOpen] = React.useState(false);

  const handleTabIndexChange = async () => {
    const filtered: any = tabs.filter((item) => {
      return item.path === windowLocation;
    });
    if (filtered[0]) {
      await setActiveTab(filtered[0].index);
    } else {
      setActiveTab(0);
      navigate(`${process.env.PUBLIC_URL}/dashboard`);
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const doLogout = () => {
    // navigate("/dashboard");
    handleCloseMenu();
    keycloak.logout();
  };

  const handleDisableTabs = (tab) => {
    if (tab === "underwriterDetails") {
      return true;
    } else {
      return false;
    }
  };

  React.useEffect(() => {
    getScreenTitle();
    handleTabIndexChange();
  }, [windowLocation]);

  return (
    <Box className={classes.insurProSidebarContainer}>
      <CssBaseline />

      <Menu
        id="profile-menu"
        anchorEl={anchorElMenu}
        open={openMenu}
        onClose={handleCloseMenu}
        MenuListProps={{
          "aria-labelledby": "basic-button-Menu",
        }}
        anchorOrigin={{
          vertical: 30,
          horizontal: 200,
        }}
        transformOrigin={{
          vertical: 0,
          horizontal: 0,
        }}
      >
        <MenuItem
          onClick={(e) => {
            handleCloseMenu();
            handleLogoClick(e);
          }}
        >
          Profile
        </MenuItem>
        <MenuItem onClick={doLogout}>Logout</MenuItem>
      </Menu>

      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        className={classes.sideBarDrawer}
        BackdropProps={{
          invisible: true,
        }}
      >
        <Box alignSelf={"center"}>
          <div className={classes.drawerLogoContainer}>
            <img
              src={InsurproLogoBlue}
              alt="I-logo"
              className={classes.drawerLogo}
            />
          </div>
          {/* <Tooltip title={logo.title} placement="right" arrow>
            <Button id="logo-button" onClick={(e) => handleLogoClick(e)}>
              <Avatar
                alt="logo"
                src={logo.icon}
                className={classes.sideBarLogo}
              />
            </Button>
          </Tooltip> */}
        </Box>

        <Tabs
          value={activeTab}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          orientation="vertical"
          variant="scrollable"
          className={classes.sideBarTabs}
        >
          {tabs
            .filter((tab: any) => tab.key !== "policyManagement")
            .map((tab: any, index) => (
              <Tooltip
                title={tab.title}
                placement="right"
                arrow
                key={tab.index}
              >
                <Tab
                  icon={
                    activeTab === index ? (
                      <div className={classes.selectEffect}>
                        <tab.icon {...selectedIcon} />
                      </div>
                    ) : (
                      <tab.icon {...unSelectedIcon} />
                    )
                  }
                  className={classes.sideBarTab}
                  {...a11yProps(tab.index)}
                  component={Link}
                  to={tab.path}
                  disabled={handleDisableTabs(tab.key)}
                />
              </Tooltip>
            ))}
        </Tabs>

        <Box className={classes.sideBarBottomContainer}>
          {/* <Box alignSelf={"center"}>
            <Tooltip title="Logout">
              <IconButton
                onClick={doLogout}
                className={classes.logoutIconStyles}
              >
                <LogoutIcon />
              </IconButton>
            </Tooltip>
          </Box> */}
          <Box className={classes.sideBarFooterContainer}>
            <Box className={classes.sideBarFooterText}>Powered by</Box>
            <img
              className={classes.sideBarFooterLogo}
              src={footerLogo}
              alt={"footer-brand logo"}
            />
          </Box>
        </Box>
      </Drawer>

      <Box className={classes.insurProMenuSection}>
        <Box className={classes.insurProMenuHeader}>
          <Button onClick={() => setOpen((prevState) => !prevState)}>
            <MenuIcon className={classes.insurProMenuIcon} />
          </Button>

          <div
            className={`${classes.logoContainer} ${
              open ? classes.hiddenDiv : ""
            }`}
          >
            <img
              src={InsurproLogo}
              alt="I-logo"
              className={classes.appLogo}
              onClick={() => navigate(`${process.env.PUBLIC_URL}/proposalList`)}
            />
          </div>

          <div className={classes.userSection}>
            <Box className={classes.insurProMenuTitle}>{screenTitle}</Box>
            <AccountCircleIcon color="primary" />
            <div className={classes.userTitle}>{logo.title}</div>
            <IconButton
              className={classes.menuDownIcon}
              onClick={handleClickMenu}
            >
              <ArrowDropDownIcon fontSize="small" />
            </IconButton>
          </div>
        </Box>
      </Box>
    </Box>
  );
}
